/**
 * Parition an array into multiple array with x count
 * @param  {array}  arr   array to partition
 * @param  {number} count groups to partition
 * @return {array}        paritioned array
 */
export default function parition(arr, count) {
  return arr.reduce((acc, item) => {
    const end = acc.length - 1;
    if (acc[end].length !== count) {
      acc[end].push(item);
    } else {
      acc.push([item]);
    }
    return acc;
  }, [[]]);
}



// WEBPACK FOOTER //
// ./app/utils/array/partition.js